import TauronLoader from './TauronLoader';

export default TauronLoader;
